/**
 * @generated SignedSource<<6f78bb9e5aba98351ea881ebcd5912f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoginBtn_viewer$data = {
  readonly user: {
    readonly orgs: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly experiments: ReadonlyArray<string | null> | null;
        } | null;
      } | null> | null;
    };
  } | null;
  readonly " $fragmentType": "LoginBtn_viewer";
};
export type LoginBtn_viewer$key = {
  readonly " $data"?: LoginBtn_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoginBtn_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LoginBtn_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000000
            }
          ],
          "concreteType": "OrgConnection",
          "kind": "LinkedField",
          "name": "orgs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Org",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "experiments",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "orgs(first:1000000)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ef4e31ac8b8d752eb5bfe964cf2feaa8";

export default node;
